const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addCustomer: ({ commit }, customer) => commit('add', customer)
};

const mutations = {
  add: (state, customer) => {
    state.byId[customer.id] = customer;
    if (state.allIds.includes(customer.id)) return;
    state.allIds.push(customer.id);
  },
  reset: state => Object.assign(state, getDefaultState())
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
